import React from 'react';

import { fg } from '@confluence/feature-gating';

import { Bm3PageLoadMark } from '../Bm3PageLoadMark.tsx';
import type { Props } from '../Bm3PageLoadMark.tsx';

/**
 * Interop component that renders either null (under UFO, since page load marks
 * are handled natively) or the legacy Bm3PageLoadMark (which creates BM3 marks)
 * based on the `confluence_fe_deprecate_bm3` feature gate.
 */
export const PageLoadMark = (props: Props) => {
	if (fg('confluence_fe_deprecate_bm3')) {
		return null;
	}

	return <Bm3PageLoadMark {...props} />;
};
